export default __webpack_public_path__ + "static/media/login-side.0a05b2da.png";